import { permit } from "../../services/authService";

function AdminWrapper({ children }: { children: any }) {
  const hasRole = permit(["admin", "superadmin"]);
  if (!hasRole) {
    return <></>; // Return null if the user is not an admin, hiding the content
  }

  return <>{children}</>;
}

export default AdminWrapper;
